import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { Autocomplete, Box, Button, Grid, TextField, Typography } from '@mui/material';
import GlobalDatagrid from '../../../components/mui/DataGrid/GlobalDatagrid';
import { BatchAdmissionRegisterTableHeader } from '../../../components/datagrid/CRD/batchAdmissionRegister/BatchAdmissionRegisterTableHeader';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  getAllAvailableCourseForBatches,
  getAllBatchNameNoPagination,
  getBatchAdmissionRegister,
} from '../../../redux/features/batchSlice';
import GlobalSelectFieldWithoutFormikNew from '../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { Icon } from '@iconify/react/dist/iconify.js';
import { getStudentsProfileForCRD } from '../../../redux/features/CRDslice';
import StudentProfileParentLand from './StudentProfileParentLand';
import ChangeBatchLanding from './ChangeBatchLanding';
import CourseCertificateLanding from './CourseCertificateLanding';
import AdmissionStatusLanding from './AdmissionStatusLanding';
import TerminationClearenceCRD from '../../crd/myworkspace/NewAdmissionRegister/components/TerminationClearence';
import { useLocation } from 'react-router-dom';
import SubjectEdit from './SubjectEdit';
import CROStudentStatus from './StudentStatus';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import ChangeTo from '../ChangeTo';
import InactiveStudentModal from './InactiveStudentModal';
import BulkStudentStatus from './BulkStudentStatus';

const StudentStatus = [
  { id: 0, name: 'All' },
  { id: 1, name: 'Active' },
  { id: 2, name: 'Inactive' },
];
const InactiveStudentStatus = [
  { id: -1, name: 'All' },
  { id: 1, name: 'Active' },
  { id: 0, name: 'Inactive' },
  { id: 2, name: 'Temporary Inactive' },
];

const BatchAdmissionRegisterLanding = () => {
  const cred = JSON.parse(localStorage.getItem('cred') || '{}');
  const isReportingHeadFromToken = cred?.profile?.isReportingHead;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const batchId = queryParams.get('BatchID');
  const { loading, batchAdmissionRegister, courses, batchesAll } = useSelector((state) => state.batch);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { pageNum, gridSize, search, checkedRowsIds } = paginationData;
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [selectedBatchId, setSelectedBatchId] = useState(batchId ? batchId : null);
  const [status, setStatus] = useState({ id: 0, name: 'All' });
  const [studentModalOpen, setStudentModalOpen] = useState(false);
  const [batchChangeModalOpen, setBatchChangeModalOpen] = useState(false);
  const [courseCertificateModalOpen, setCourseCertificateModalOpen] = useState(false);
  const [admissionStatusModalOpen, setAdmissionStatusModalOpen] = useState(false);
  const [subjectEditModalOpen, setSubjectEditModalOpen] = useState(false);
  const [changeStudentStatusModalOpen, setChangeStudentStatusModalOpen] = useState(false);
  const [inactiveStudentModalOpen, setInactiveStudentModalOpen] = useState(false);
  const [bulkStatusModalOpen, setBulkStatusModalOpen] = useState(false);
  const [gridKey, setGridKey] = useState(0); // bump to clear checkbox selection after a bulk update
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedInactiveStudentStatus, setSelectedInactiveStudentStatus] = useState({ id: -1, name: 'All' });
  // const [assignCroModalOpen, setAssignCroModalOpen] = useState(false);
  const [selectedCro, setSelectedCro] = useState(null);
  const dispatch = useDispatch();
  const [currentRowDetails, setCurrentRowDetails] = useState(null);
  const dispatchParams = {
    paginationData,
    courseId: selectedCourseId || null,
    batchId: selectedBatchId || null,
    statusId: status?.id || null,
    inactiveStudentStatusId: selectedInactiveStudentStatus?.id === -1 ? null : selectedInactiveStudentStatus?.id,
  };

  const [changeTo, setChangeTo] = useState(false);
  const studentStatusOptions = [
    { id: 1, name: 'Inactive' },
    { id: 2, name: 'Temporary Inactive' },
  ];

  useEffect(() => {
    dispatch(getAllAvailableCourseForBatches());
    dispatch(
      getAllBatchNameNoPagination({
        isAllBatchesNeeded: batchId ? true : false,
      }),
    );
  }, [batchId]);

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getBatchAdmissionRegister(dispatchParams));
    }
  }, [pageNum, gridSize, search, selectedCourseId, selectedBatchId, status, selectedInactiveStudentStatus]);

  const handleChange = (name, value) => {
    if (name === 'courseId') {
      setSelectedCourseId(value);
    } else if (name === 'batchId') {
      setSelectedBatchId(value);
    }
  };

  // const handleAssignCro = () => {
  //   const payload = {
  //     croId: selectedCro?.employee_id,
  //     studentIds: checkedRowsIds,
  //   };

  //   dispatch(assignStudentsToCro(payload));
  // };

  const handleAssignCro = () => {
    const payload = {
      croId: selectedCro?.employee_id,
      studentIds: checkedRowsIds,
    };

    console.log(payload);
  };

  const columns = useMemo(
    () => [
      ...BatchAdmissionRegisterTableHeader,
      {
        field: 'changeTo',
        minWidth: 200,
        headerName: 'Move To Internship',
        renderCell: (params) => {
          return (
            <Button
              size="small"
              color="primary"
              variant="outlined"
              startIcon={<Icon icon={'material-symbols-light:change-circle'} width={18} height={18} />}
              onClick={() => {
                setChangeTo(params.row);
              }}
            >
              Move
            </Button>
          );
        },
      },
      {
        field: 'action',
        headerName: 'Action',
        width: 1600,
        renderCell: (params) => (
          <Box display="flex" gap={1}>
            <Button
              startIcon={<Icon icon="mdi:eye" />}
              variant="outlined"
              size="small"
              onClick={() => {
                setSelectedRow(params.row);
                setStudentModalOpen(true);
              }}
            >
              View Student Profile
            </Button>
            <Button
              startIcon={<Icon icon="material-symbols-light:change-circle-rounded" />}
              variant="outlined"
              size="small"
              onClick={() => {
                setSelectedRow(params.row);
                setBatchChangeModalOpen(true);
              }}
            >
              Change Batch
            </Button>
            <Button
              disabled={!isReportingHeadFromToken}
              startIcon={<Icon icon="mdi:certificate" />}
              variant="outlined"
              size="small"
              onClick={() => {
                setSelectedRow(params.row);
                setCourseCertificateModalOpen(true);
              }}
            >
              Course Certificate
            </Button>
            <Button
              disabled={isReportingHeadFromToken}
              startIcon={<Icon icon="hugeicons:status" />}
              variant="outlined"
              size="small"
              onClick={() => {
                setSelectedRow(params.row);
                setAdmissionStatusModalOpen(true);
              }}
            >
              Update Admission Status
            </Button>
            <Button
              sx={{ px: 1 }}
              startIcon={<Icon icon="famicons:navigate" />}
              variant="outlined"
              size="small"
              onClick={() => {
                window.open(
                  `/my-workspace/student-attendance?batchAssignmentId=${params.row.batch_assignment_id}`,
                  '_blank',
                );
              }}
            >
              Student Attendance View
            </Button>
            <Button
              startIcon={<Icon icon="hugeicons:status" />}
              variant="outlined"
              size="small"
              onClick={() => {
                setSelectedRow(params.row);
                setSubjectEditModalOpen(true);
              }}
            >
              Update Student's Subject
            </Button>
            <Button
              startIcon={<Icon icon="ion:person-outline" />}
              variant="outlined"
              size="small"
              onClick={() => {
                setSelectedRow(params.row);
                setChangeStudentStatusModalOpen(true);
              }}
            >
              Update Student Status
            </Button>

            {/* inactive student  */}

            <Button
              startIcon={<Icon icon="ion:person-outline" />}
              variant="outlined"
              size="small"
              onClick={() => {
                setSelectedRow(params.row);
                setInactiveStudentModalOpen(true);
              }}
            >
              Inactive Student
            </Button>
          </Box>
        ),
      },
      // {
      //   field: "changeBatch",
      //   headerName: "Action",
      //   width: 160,
      //   renderCell: (params) => (

      //   ),
      // },
      // {
      //   field: "courseCertificate",
      //   headerName: "Action",
      //   width: 180,
      //   renderCell: (params) => (

      //   ),
      // },
      // {
      //   field: "terminationClearance",
      //   headerName: "Action",
      //   width: 230,
      //   renderCell: (params) => (

      //   ),
      // },
      // {
      //   field: "studentAttndence",
      //   headerName: "Action",
      //   width: 230,
      //   renderCell: (params) => (

      //   ),
      // },
    ],
    [],
  );
  return (
    <GlobalWrapper title={'Batch Student Register'}>
      <Box mb={1}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Box>
              <Autocomplete
                name={'courseId'}
                fullWidth
                options={courses}
                getOptionLabel={(option) => option.course_name || ''}
                value={courses.find((data) => data.course_available_id == selectedCourseId) || null}
                onChange={(e, option) => handleChange('courseId', option?.course_available_id)}
                renderInput={(params) => <TextField fullWidth autoComplete="off" {...params} label="Course" />}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <GlobalSelectFieldWithoutFormikNew
                keys={{ itemId: 'id', itemValue: 'name' }}
                data={StudentStatus}
                label={'Status'}
                fullWidth={true}
                selectedDetails={status}
                setChange={setStatus}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Box>
              <Autocomplete
                name={'batchId'}
                fullWidth
                options={batchesAll}
                getOptionLabel={(option) => option.course_batch_name || ''}
                value={batchesAll?.find((data) => data?.course_batch_id == selectedBatchId) || null}
                onChange={(e, option) => handleChange('batchId', option?.course_batch_id)}
                renderInput={(params) => <TextField fullWidth autoComplete="off" {...params} label="Batch" />}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Box>
              <GlobalSelectFieldWithoutFormikNew
                keys={{ itemId: 'id', itemValue: 'name' }}
                data={InactiveStudentStatus}
                label={'Inactive Student Status'}
                fullWidth={true}
                selectedDetails={selectedInactiveStudentStatus}
                setChange={setSelectedInactiveStudentStatus}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} display="flex" alignItems="center">
            <Button
              variant="contained"
              startIcon={<Icon icon="ion:people-outline" />}
              disabled={!checkedRowsIds?.length}
              onClick={() => setBulkStatusModalOpen(true)}
            >
              Bulk Update Student Status{checkedRowsIds?.length ? ` (${checkedRowsIds.length})` : ''}
            </Button>
          </Grid>
          {/* <Grid item xs={12} sm={6} md={4} lg={3}>
            <Box>
              <Button
                variant="contained"
                disabled={!checkedRowsIds?.length}
                onClick={() => setAssignCroModalOpen(true)}
              >
                Assign CRO
              </Button>
            </Box>
          </Grid> */}
          {/*  <Grid item xs={12} sm={6} md={4} lg={3} sx={{ justifySelf: 'flex-end' }}>
            <Button
              variant="contained"
              disabled={!Boolean(checkedRowsIds?.length)}
              onClick={() => setChangeTo(checkedRowsIds)}
            >
              Bulk Move To Internship
            </Button>
          </Grid> */}
        </Grid>
      </Box>
      <Box>
        {currentRowDetails?.studentName && (
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
            Student Name : <strong>{currentRowDetails?.studentName}</strong>
          </Typography>
        )}
        <GlobalDatagrid
          key={gridKey}
          tableHead={columns}
          rows={batchAdmissionRegister.data}
          meta={batchAdmissionRegister?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="batch_assignment_id"
          rowClick={false}
          setCurrentRowDetails={setCurrentRowDetails}
          checkboxSelection={true}
          disableSelectionOnClick
        />

        {bulkStatusModalOpen && (
          <BulkStudentStatus
            open={bulkStatusModalOpen}
            setOpen={setBulkStatusModalOpen}
            batchAssignmentIds={checkedRowsIds || []}
            dispatchParams={dispatchParams}
            onSuccess={() => setGridKey((prev) => prev + 1)}
          />
        )}

        {studentModalOpen && (
          <StudentProfileParentLand
            url={getStudentsProfileForCRD}
            storeName={'crd'}
            courseEnrollmentId={selectedRow?.course_enrollment_id}
            open={studentModalOpen}
            setOpen={setStudentModalOpen}
          />
        )}
        {batchChangeModalOpen && (
          <ChangeBatchLanding
            open={batchChangeModalOpen}
            setOpen={setBatchChangeModalOpen}
            batchesAll={batchesAll}
            rowData={selectedRow}
            dispatchParams={dispatchParams}
            loading={loading}
          />
        )}
        {courseCertificateModalOpen && (
          <CourseCertificateLanding
            open={courseCertificateModalOpen}
            setOpen={setCourseCertificateModalOpen}
            batchesAll={batchesAll}
            dispatchParams={dispatchParams}
            loading={loading}
            courseEnrollmentId={selectedRow?.course_enrollment_id}
          />
        )}
        {admissionStatusModalOpen && (
          <AdmissionStatusLanding
            open={admissionStatusModalOpen}
            setOpen={setAdmissionStatusModalOpen}
            dispatchParams={dispatchParams}
            loading={loading}
            CourseEnrollmentId={selectedRow?.course_enrollment_id}
            batchAssignmentId={selectedRow?.batch_assignment_id}
          />
        )}
        {subjectEditModalOpen && (
          <SubjectEdit
            open={subjectEditModalOpen}
            setOpen={setSubjectEditModalOpen}
            rowData={selectedRow}
            dispatchParams={dispatchParams}
            loading={loading}
          />
        )}
        {changeStudentStatusModalOpen && (
          <CROStudentStatus
            open={changeStudentStatusModalOpen}
            setOpen={setChangeStudentStatusModalOpen}
            rowData={selectedRow}
            dispatchParams={dispatchParams}
            loading={loading}
          />
        )}
        {inactiveStudentModalOpen && (
          <InactiveStudentModal
            open={inactiveStudentModalOpen}
            setOpen={setInactiveStudentModalOpen}
            rowData={selectedRow}
            batchesAll={batchesAll}
            dispatchParams={dispatchParams}
            loading={loading}
          />
        )}
        <GlobalDialog
          title={'Move To Internship'}
          content={<ChangeTo row={changeTo} setOpen={setChangeTo} />}
          open={Boolean(changeTo)}
          setOpen={setChangeTo}
          closeButton={true}
          maxWidth={'sm'}
          fullWidth
        />
        {/* <GlobalDialog
          title="Assign CRO"
          open={assignCroModalOpen}
          setOpen={setAssignCroModalOpen}
          maxWidth={'sm'}
          fullWidth
          closeButton={true}
          content={
            <Box>
              <Autocomplete
                options={croList}
                getOptionLabel={(option) => option.employee_name || ''}
                onChange={(e, value) => setSelectedCro(value)}
                renderInput={(params) => <TextField {...params} label="Select CRO" />}
              />

              <Button sx={{ mt: 2 }} variant="contained" onClick={handleAssignCro}>
                Submit
              </Button>
            </Box>
          }
        /> */}
      </Box>
    </GlobalWrapper>
  );
};

export default BatchAdmissionRegisterLanding;
